import { createContext } from 'react';
import type { Account } from '../api/auth';

export interface AuthState {
  /** null once we know nobody is signed in. */
  account: Account | null;
  /** True until the first session check resolves. */
  isLoading: boolean;
  signIn: (email: string, password: string) => Promise<Account>;
  signOut: () => Promise<void>;
  /** Replace the cached account after an update, e.g. a profile edit. */
  setAccount: (account: Account) => void;
  refresh: () => Promise<void>;
}

export const AuthContext = createContext<AuthState | null>(null);
